import Repository from "./repository";

const resource = "/api/v1/approval";

export default {
  getApprovalLinesList(params) {
    return Repository.get(`${resource}/lines/data-table`, { params });
  },
};
